import { Box, CircularProgress, Divider, Icon, Typography } from '@mui/material'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import { useState } from 'react'
import { getReceipt } from 'services/api/modules/recruitment/order'
import { downloadUrlFile, notifyDownloadError } from 'services/helper/fileDownload'
import useOpenClose from 'services/hooks/useOpenClose'
import ViewListDialog from './ViewListDialog'
import AdxButton from 'components/custom/AdxButton'

const TransactionDetailDrawer = ({ drawerState, handleDrawer, data, isLoading }) => {
  //modal
  const viewListDialog = useOpenClose(false)

  //set order id
  const id = data.reference_id

  const [isLoadingDownload, setIsLoadingDownload] = useState(false)

  //api call for download receipt
  const handleDownload = async () => {
    setIsLoadingDownload(true)
    try {
      const pdfLink = await getReceipt(id)
      setIsLoadingDownload(false)
      downloadUrlFile({
        url: pdfLink,
        fileName: `${id}_invoice.pdf`,
        successMessage: 'Receipt downloaded.',
        revokeObjectUrl: true,
      })
    } catch (error) {
      setIsLoadingDownload(false)
      notifyDownloadError('Unable to download receipt. Please try again.')
      console.log(error)
    }
  }
  // change date format
  const dt = new Date(data.updated_at ?? null)
  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
  const formattedDate = formatter.format(dt)

  //check of the time is in PM and the hour clock is 00, change it 12
  const [dateString, time] = formattedDate.split(', ')
  const [hour, minuteTemp] = time.split(':')
  const [minute, ampm] = minuteTemp.split(' ')
  const convertTime = (ampm, dateString, minuteTemp, hour, formattedDate) => {
    if (ampm === 'pm' && hour === '00') {
      return `${dateString}, 12:${minuteTemp}`
    } else {
      return formattedDate
    }
  }
  const newDate = convertTime(ampm, dateString, minuteTemp, hour, formattedDate)

  if (isLoading) {
    return (
      <Box>
        <AdxDrawerComponent
          state={drawerState}
          anchor="right"
          onClose={handleDrawer}
          sx={{ padding: 0 }}
          sxIcon={{ marginRight: 6.25, marginY: 6.25 }}
          headerprops={
            <Box padding={0}>
              <Typography variant="h4" px={2}>
                Transaction detail
              </Typography>
            </Box>
          }
          sxHeader={{ height: 50 }}
        >
          <Box display="flex" alignItems="center" justifyContent="center" mt={30}>
            <CircularProgress color="alternate" />
          </Box>
        </AdxDrawerComponent>
      </Box>
    )
  } else {
    return (
      <Box>
        <AdxDrawerComponent
          state={drawerState}
          anchor="right"
          onClose={handleDrawer}
          sx={{ padding: 0, width: { xs: '100vw', lg: 600 } }}
          sxIcon={{ marginRight: 6.25, marginY: 6.25 }}
          headerprops={
            <Box padding={0}>
              <Typography variant="h4" px={2}>
                Transaction detail
              </Typography>
            </Box>
          }
          sxHeader={{ height: 50 }}
        >
          <Divider />
          <Box>
            <Box
              padding={6.25}
              display="flex"
              justifyContent="center"
              bgcolor="gray-background.main"
            >
              {data.order_type === 'credit_purchase' ? (
                <Typography variant="h2" color="alternate.main">
                  + RM {data.amount}
                </Typography>
              ) : (
                <Typography variant="h2" color="error.main">
                  - RM {data.amount}
                </Typography>
              )}
            </Box>
            <Box
              px={4}
              py={2}
              sx={{
                borderBottom: '2px solid',
                borderBottomColor: 'gray-line.main',
              }}
            >
              <Box display="flex" columnGap={18}>
                <Typography variant="h4" color="light-gray-text.main" width={150}>
                  Status
                </Typography>
                {data.order_status === 'Payment successful' ? (
                  <Typography
                    variant="h4"
                    color="dark-text.main"
                    textAlign="left"
                    display="flex"
                    alignItems="center"
                    gap={1}
                    width={200}
                  >
                    {' '}
                    <Icon sx={{ color: 'positive.main' }}>check_circle_icon</Icon> Successful
                  </Typography>
                ) : (
                  <Typography variant="h4" color="error.main" textAlign="left" width={200}>
                    Failed
                  </Typography>
                )}
              </Box>
              <Box mt={2} display="flex" columnGap={18}>
                <Typography variant="h4" color="light-gray-text.main" width={150}>
                  Time
                </Typography>
                <Typography variant="h4" color="dark-text.main" textAlign="left" width={200}>
                  {newDate}
                </Typography>
              </Box>
            </Box>
            <Box px={4} py={2}>
              <Box display="flex" columnGap={18}>
                <Typography variant="h4" color="light-gray-text.main" width={150}>
                  Transaction
                </Typography>
                {data.order_type === 'candidate_purchase' ? (
                  <Typography variant="h4" color="dark-text.main" textAlign="left" width={200}>
                    Candidate purchase
                  </Typography>
                ) : (
                  <Typography variant="h4" color="dark-text.main" textAlign="left" width={200}>
                    Credit topup
                  </Typography>
                )}
              </Box>

              {data.order_type === 'credit_purchase' ? (
                <Box mt={2} display="flex" columnGap={18}>
                  <Typography variant="h4" color="light-gray-text.main" width={150}>
                    Payment method
                  </Typography>

                  <Typography variant="h4" color="dark-text.main" textAlign="left" width={200}>
                    {data.payment_method}
                  </Typography>
                </Box>
              ) : null}
              {/* {data.order_type==="credit_purchase"?
                       <Box>
                           <Box
                            display="flex"
                            columnGap={18}
                            mt={2}
                            >
                            <Typography
                                variant="h4"
                                color="light-gray-text.main"
                                width={150}
                            >Package
                            </Typography>
                           { itemList[0]?.credit_value===150?
                           <Typography
                                variant="h4"
                                color="dark-text.main"
                                textAlign="left"
                                width={200}
                            >Starter
                            </Typography>:null }
                           { itemList[0]?.credit_value===250?
                           <Typography
                                variant="h4"
                                color="dark-text.main"
                                textAlign="left"
                                width={200}
                            >Standard
                            </Typography>:null }
                           { itemList[0]?.credit_value===500?
                           <Typography
                                variant="h4"
                                color="dark-text.main"
                                textAlign="left"
                                width={200}
                            >Big bundle
                            </Typography>:null }
                            </Box>
                            <Box
                            display="flex"
                            columnGap={18}
                            mt={2}
                            >
                            <Typography
                                variant="h4"
                                color="light-gray-text.main"
                                width={150}
                            >Total payment
                            </Typography>
                            <Typography
                                variant="h4"
                                color="dark-text.main"
                                textAlign="left"
                                width={200}
                            >RM {itemList[0]?.credit_value}.00
                            </Typography>
                            </Box>
                       </Box>
                        :null} */}
              <Box mt={2} display="flex" columnGap={18}>
                <Typography variant="h4" color="light-gray-text.main" width={150}>
                  Transaction ID
                </Typography>
                <Typography variant="h4" color="dark-text.main" textAlign="left" width={200}>
                  {data.transaction_id}
                </Typography>
              </Box>

              <Box mt={2} display="flex" columnGap={18}>
                <Typography variant="h4" color="light-gray-text.main" width={150}>
                  Reference ID
                </Typography>
                <Typography variant="h4" color="dark-text.main" textAlign="left" width={200}>
                  {data.reference_id}
                </Typography>
              </Box>
            </Box>
            <Box
              mt={12}
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
              gap={2}
            >
              {data.order_type === 'candidate_purchase' &&
              data.order_status === 'Payment successful' ? (
                <AdxButton
                  variant={'outlined'}
                  size="standard"
                  onClick={viewListDialog.handleOpen}
                  sx={{ width: 3 / 4 }}
                >
                  View purchased candidate
                </AdxButton>
              ) : null}
              <AdxButton
                variant={'outlined'}
                disabled={data.order_status !== 'Payment successful'}
                isLoading={isLoadingDownload}
                size="standard"
                sx={{ width: 3 / 4 }}
                onClick={handleDownload}
              >
                Download receipt
              </AdxButton>
            </Box>
          </Box>
        </AdxDrawerComponent>
        {viewListDialog.isOpen ? (
          <ViewListDialog
            id={data.id}
            open={viewListDialog.isOpen}
            handleClose={viewListDialog.handleClose}
          />
        ) : null}
      </Box>
    )
  }
}
export default TransactionDetailDrawer
